import axios from 'axios'

const host = 'https://api.bzaoyin.com'

/**
 * 获取音乐列表
 * @param {Number} pageNow 当前页
 * @param {Number} pageSize 每页个数
 * @param {Number} type 音乐分组类型
 */
export const getAllMusicList = ({ pageNow = 1, pageSize = 99, type = 1 }) => {
  return axios.post(`${host}/music/list`, { pageNow, pageSize, type })
}

/**
 * 上传音频
 * @param {String} musicName 音频名字
 * @param {Number} type 类型
 * @param {String} musicUrl 地址
 * @param {Number} sort 排序
 */
export const uploadMusic = ({ musicName, type, musicUrl, sort }) => {
  return axios.post(`${host}/music/upload`, { musicName, type, musicUrl, sort })
}
